/**
 * RevisionProgramScreen — primary adapter for the parent "Programme de révision" detail.
 *
 * Cache-only: reads `studyPrograms` / `current_study_programs` via the view-model (no API fetch —
 * backoffice `getStudyProgram` is admin-only and 403s for parent/student tokens).
 * Wires: revisionProgramViewModel + useRevisionProgramState (back) → DS `<RevisionProgramPage>`.
 */
import { useSelector } from "react-redux"

import { RevisionProgramPage } from "../../../../../../design-system"
import { revisionProgramViewModel } from "../../../../view-models/parent/RevisionProgram/revisionProgramViewModel"
import { useRevisionProgramState } from "./useRevisionProgramState"

export type RevisionProgramScreenProps = {
    /** From React Navigation `study-program` route. */
    route?: { params?: { id?: string | number } | null } | null
}

export function RevisionProgramScreen(props: RevisionProgramScreenProps) {
    const programId = props.route?.params?.id
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const vm = useSelector((state: any) => revisionProgramViewModel(state, programId))
    const { actions } = useRevisionProgramState()

    return <RevisionProgramPage groups={vm.groups} onClose={actions.close} />
}

export default RevisionProgramScreen
